import React, { Component, useState } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Tag,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;
class RawMaterialVariantDetail extends Component {
  constructor() {
    super();
  }
  state = {
    id: "",
    details: [],
    newdetails: [],
    data: [],
    type: "",
    material: "",
    variant: "",
  };

  componentDidMount() {
    const details = [];
    axios
      .get(
        `${getServerUrl()}/inventory/getmaterialstocktypevariant/${
          this.props.match.params.id
        }/${this.props.match.params.variant}`,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      )
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        this.setState({
          type: details[0].raw_material_type_name,
          material: details[0].raw_material_name,
          variant: details[0].rawvariant,
        });
        this.setState({ details });
      });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  render() {
    const data = this.state.details;
    const columns = [
      {
        title: "Vendor Name",
        dataIndex: "contractor_name",
        key: "contractor_name",
        ...this.getColumnSearchProps("contractor_name"),
      },
      {
        title: "Raw Material Type",
        dataIndex: "raw_material_type_name",
        key: "raw_material_type_name",
        ...this.getColumnSearchProps("raw_material_type_name"),
      },
      {
        title: "Raw Material Name",
        dataIndex: "raw_material_name",
        key: "raw_material_name",
        ...this.getColumnSearchProps("raw_material_name"),
      },
      {
        title: "Raw Material Variant",
        dataIndex: "rawvariant",
        key: "rawvariant",
        ...this.getColumnSearchProps("rawvariant"),
      },
      {
        title: "Inward Qty",
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: "Outward Qty",
        dataIndex: "componentused",
        key: "componentused",
        render: (text, record) => Number(record.usedquantity).toFixed(2),
      },
      {
        title: "Closing Stock",
        dataIndex: "remainquantity",
        key: "remainquantity",
        render: (text, record) =>
          (Number(record.quantity) - Number(record.usedquantity)).toFixed(2),
      },
      {
        title: "Action",
        dataIndex: "raw_material_id",
        key: "raw_material_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink
              to={
                "/raw-material-variant-by-vendor/" +
                record.contractor +
                "/" +
                record.raw_material_id +
                "/" +
                record.rawvariant
              }
            >
              View in details
            </NavLink>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Inventory </Breadcrumb.Item>
          <Breadcrumb.Item>Raw Material Stock</Breadcrumb.Item>
          <Breadcrumb.Item>{this.state.type}</Breadcrumb.Item>
          <Breadcrumb.Item>{this.state.material}</Breadcrumb.Item>
          <Breadcrumb.Item>{this.state.variant}</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            {this.state.type} / {this.state.material} / {this.state.variant}
          </h2>

          <Space></Space>
          <br />
          <Table columns={columns} dataSource={data}></Table>
        </div>
      </div>
    );
  }
}

export default RawMaterialVariantDetail;
